import { Component, computed, inject, signal } from '@angular/core';
import { Route } from '../../utils/route';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { provideIcons } from '@ng-icons/core';
import {
  iconoirOpenInWindow,
  iconoirPhone,
  iconoirDatabaseScript,
  iconoirUser,
  iconoirHandbag,
  iconoirHealthShield,
  iconoirRefresh,
} from '@ng-icons/iconoir';
import { ProductsTabComponent } from './products-tab/products-tab.component';

@Component({
  selector: 'app-products',
  imports: [TabsComponent, ProductsTabComponent],
  providers: [provideIcons({})],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
})
export class ProductsComponent extends Route {}
